<div class="body">

    <div class="afiliado">

        <div class="container" style="height:50px"> </div>

        <div class="container">

            <div class="row">

                <div class="col-lg-10"> </div>

                <div class="col-lg-2" *ngIf="rol == 'ROLE_ADMINISTRADOR'">
                    <button class="btn btn-success" (click)="crearUsuario()">

                        <i class="fa fa-plus"></i> Crear Usuario </button>

                </div>

            </div>

        </div>

        <div class="container" style="height:50px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-6">
                    <h1> Listado de Usuarios </h1>
                </div>

                <div class="col-lg-3"> </div>

                <div class="col-lg-2">
                    <!--  <h3> Cantidad de Registros </h3> -->
                </div>

                <div class="col-lg-1">
                    <!--
                    <select class="form-control" (change)="cambiaCantidadRegistros()" [(ngModel)]="config.itemsPerPage">

                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>

                    </select>
                     -->
                </div>

            </div>
            <hr /> <br />

            <div class="row">

                <div class="col-lg-2">
                    <h3> Correo de Usuario: </h3>
                </div>

                <div class="col-lg-3">
                    <form (submit)="buscar()" action="#">
                        <input name="afiliado" class="form-control" [(ngModel)]="buscador.correo"
                            placeholder="Ingrese el correo del afiliado" />
                    </form>
                </div>

                <div class="col-lg-2">
                    <h3> RUT de Usuario: </h3>
                </div>

                <div class="col-lg-3">
                    <form (submit)="buscar()" action="#">
                        <input name="rut" class="form-control" id="txt_rut" type="text" #rut="ngModel"
                            [(ngModel)]="buscador.rut" placeholder="Ingrese el RUT (11111111-1)"
                            pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />
                    </form>
                </div>


                <div class="col-lg-2">
                    <button class="btn btn-info" (click)="buscar()">
                        <i class="fa fa-search"></i> Buscar </button>
                </div>

            </div> <br /> <br />

            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> N° </th>

                            <th scope="col"> Rut </th>

                            <th scope="col"> Nombre y Apellido </th>

                            <th scope="col"> Fecha Ingreso </th>

                            <th scope="col"> Correo </th>

                            <th scope="col"> Estado </th>

                            <th scope="col"> Editar </th>

                            <th scope="col" *ngIf="rol == 'ROLE_ADMINISTRADOR'"> Activar / Desactivar </th>
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'"
                            *ngFor="let usuario of usuariosFinales | paginate: config; let i = index">

                            <td> {{usuario.id}} </td>

                            <td> {{usuario.rut}} - {{usuario.dv}} </td>

                            <td> {{usuario.nombres}} {{usuario.apellidoPaterno}} {{usuario.apellidoMaterno}} </td>

                            <td> {{usuario.fechaAfiliado}} </td>

                            <td> {{usuario.mail}} </td>

                            <td> {{usuario.estado}} </td>

                            <td> <button class="btn btn-warning" (click)="editarUsuario(usuario.id)"
                                    style="width:100px">

                                    <i class="fa fa-pen"> </i> Editar

                                </button> </td>

                            <td *ngIf="rol == 'ROLE_ADMINISTRADOR'"> <button class="btn btn-danger"
                                    (click)="modificarEstadoUsuario(usuario.id, usuario.estado)" style="width:120px">

                                    <i class="fa fa-pen"> </i> Modificar

                                </button></td>

                        </tr>

                    </tbody>

                </table> <br />

                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente"
                    (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>

            </div>

        </div>

        <div class="container" style="height:100px"> </div>

    </div>

</div>